document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.coming-soon-collection__notify-trigger').forEach((trigger) => {
    const modal = document.getElementById(trigger.id.replace('notify-trigger-', 'notify-modal-'));
    if (!modal) return;

    const closeElements = modal.querySelectorAll('[data-close-modal]');

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const firstInput = modal.querySelector('input');
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', openModal);
    closeElements.forEach((el) => el.addEventListener('click', closeModal));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
});